import MyBarChart from "../charts/MyBarChart";
// import {useEffect, useState} from "react";
import TeamsTable from "./TeamsTable";
// import {getCookie} from "../service/cookie";
// import axios from "axios";
// import appConfig from "../service/config";
// import getErrorMessage from "../service/getError";

const TipsByTeams = ({teams}) => {

  if(!teams) {
    return <></>
  }
  const teamsList = teams.stats.tips_by_team
  return (
    <div className="tips-by-teams">
      <h4>Tips By Teams</h4>
      <MyBarChart
        data={teamsList}
        bg_color_success="#aaa"
      />
      <TeamsTable data={teamsList}/>
    </div>
  )
}

export default TipsByTeams
